import * as React from 'react';
import { FaSpinner } from 'react-icons/fa';
export const Spinner = ({ text = '' }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FaSpinner className="fa-spin" style={{ fontSize: '3em' }}/>
      {text && (
        <div style={{ marginLeft: '15px', fontStyle: 'italic' }}>{text}</div>
      )}
    </div>
  )
}
